<template>
  <b-container fluid>
    <TransitionGroup>
         <div v-if="deleteWorkoutPlanSuccessful" role="alert" aria-live="polite" aria-atomic="true" class="alert text-white bg-primary alert-dismissible">
            <button @click="deleteWorkoutPlanSuccessful = false" type="button" aria-label="Close" class="close">×</button>
            <div class="iq-alert-text">Workout plan deleted.</div>
        </div>
         <div v-if="createWorkoutPlanSuccessful" role="alert" aria-live="polite" aria-atomic="true" class="alert text-white bg-primary alert-dismissible">
            <button @click="createWorkoutPlanSuccessful = false" type="button" aria-label="Close" class="close">×</button>
            <div class="iq-alert-text">Workout plan Created.</div>
        </div>
    </TransitionGroup>
    <b-row>
      <b-col lg="4">
        <iq-card class="profile-block">
          <template v-slot:default>
            <div class="user-details-block" v-if="patient && doctor">
              <div class="user-profile text-center">
                <img v-if="patient.profilePic" :src="patient.profilePic" alt="profile-img" class="profile-pic">
                <img v-else src="../../assets/images/page-img/48.png" alt="profile-img" class="avatar-130 img-fluid">
              </div>
              <div class="text-center mt-3 top-info">
                <h4><b>{{ patient.firstName }} {{patient.lastName }}</b></h4>
                <p>{{ patient.email }}</p>
                <button v-if="!isMyPatient" class="btn btn-primary" @click="addPatient">Add Patient</button>
                <button v-else @click="deletePatient" class="btn btn-secondary">Delete From My Patients</button>
              </div>
              <hr>
              <ul class="doctoe-sedual d-flex align-items-center justify-content-between p-0">
                <li class="text-center">
                  <h3 v-if="patient.exerciseCount" class="counter">{{ patient.exerciseCount }}</h3>
                  <h3 v-else class="counter">0</h3>
                  <span>Workouts</span>
                </li>
                <li class="text-center">
                  <h3 class="counter">0</h3>
                  <span>Appointments</span>
                </li>
              </ul>
            </div>
          </template>
        </iq-card>
      </b-col>
      <b-col lg="8">
        <PatientStatsVue :uid="uid"/>
      </b-col>
    </b-row>
    <b-row>
    <b-col lg="4">
        <CreateWorkoutPlan v-if="publicWorkoutPlans" @workoutPlanDeleted="workoutPlanDeleted"
             @workoutPlanCreated="workoutPlanCreated"
            :workoutPlans="publicWorkoutPlans" :isMyPatient="isMyPatient" :autocapitalize=true :isPublic=true draggableId="publicDraggables">
        </CreateWorkoutPlan>
        <CreateWorkoutPlan v-if="personalizedWorkoutPlans" @workoutPlanDeleted="workoutPlanDeleted"
             @workoutPlanCreated="workoutPlanCreated" @calendarRefreshNeeded="refreshCalendar"
            :workoutPlans="personalizedWorkoutPlans" :isMyPatient="isMyPatient" :isPublic=false draggableId="personalDraggables"
            :patientUid="uid">
        </CreateWorkoutPlan>
      </b-col>
        <b-col lg="8">
        <iq-card>
          <template v-slot:headerTitle>
            <h4 class="card-title">Workout Schedule
                 <Popper v-if="isMyPatient" :hover="true" placement="right" :arrow="true">
                <button class="btn info-btn"><i class="ion-help-circled"></i></button>
                    <template #content>
                    <div class="popper-content">
                    <p>Drag and drop plans into calendar.</p><p>Or, click on the add button.</p>
                    </div></template>
                </Popper></h4>
          </template>
          <template v-slot:headerAction>
            <button v-if="isMyPatient" class="btn btn-icon" @click="modalShow = !modalShow">
              <i class="fa fa-plus  mr-0" aria-hidden="true" />
            </button>
          </template>
          <template v-slot:default>
            <FullCalendar ref="fullCalendar" id="calendar" :options="calendarOptions" />
                      <div>
            <b-modal title="New Event" v-model="modalShow" okTitle="Create" scrollable no-close-on-backdrop
              @ok="scheduleEventsUsingModal" @cancel="resetModal" :busy="updateCalendarPending">
              <div>
                    <div class="form-group">
                      <label>Select a date</label>
                      <div :class="{'is-invalid': noDateInput}">
                          <flat-pickr @on-change="dateChanged"
                              v-model="date"
                              :config="pickrConfig"
                              class="bg-white"
                              placeholder="Select date"
                              name="date"
                              />
                      </div>
                    </div>
                    <div class="form-group">
                    <label for="name">Workout Plan:</label>
                    <div class="searchbox" :class="{ 'is-invalid': noEventsInput }">
                      <ul v-if="selectedPlans.length > 0" class="list-inline d-inline-block mb-2">
                          <li v-for="(plan, index) in selectedPlans" :key="index" class="list-inline-item">
                            <b-form-tag @remove="removePlan(index)" :title="plan.name" class="tag">{{ plan.name }}</b-form-tag>
                          </li>
                      </ul>
                      <b-input-group class="search-box-wrapper">
                        <input type="text" class="text search-input" placeholder="Search by device or workout name"
                        v-model="searchInput">
                      </b-input-group>
                    <div v-if="searchInput">
                        <ul v-for="plan in foundPlans" :key="plan.id" class="plan-list">
                            <li><button @click="addPlan(plan), resetInput()" class="btn plan-btn">
                            <span class="text">{{ plan.name }}</span>
                            <div v-if="plan.exerciseArray">
                            <span class="muted-text" v-for="(exercise, index) in plan.exerciseArray" :key="index">
                            <small>{{ exercise }} x {{ plan.reps[index] }}</small><samll v-if="index < plan.exerciseArray.length-1">, </samll>
                            </span>
                            </div>
                            <div v-else>
                            <span v-for="(reps, name, index) in plan.exercises" :key="name">
                            <small>{{ name }} x {{ reps }}</small><samll v-if="index < Object.keys(plan.exercises).length - 1">, </samll>
                            </span>
                            </div>
                            </button></li>
                        </ul>
                    </div>
                      </div>
                      </div>
                      </div>
            </b-modal>
          </div>
          </template>
        </iq-card>
      </b-col>
    </b-row>
  </b-container>
</template>
<script>
import IqCard from '../../components/xray/cards/iq-card'
import { xray } from '../../config/pluginInit'
import getDocument from '../../services/getDocument'
import getCollection from '../../services/getCollection'
import { updateDocument, createDocument } from '../../services/useDocument'
import firebase from '../../../firebase'
import { arrayRemove, arrayUnion } from '@firebase/firestore'
import { ref, watch } from 'vue'
import FullCalendar from '@fullcalendar/vue3'
import dayGridPlugin from '@fullcalendar/daygrid'
import interactionPlugin, { Draggable } from '@fullcalendar/interaction'
import Popper from 'vue3-popper'
import CreateWorkoutPlan from '../../components/WorkoutPlan.vue'
import { doc, getDoc, updateDoc, deleteField } from 'firebase/firestore'
import { v4 as uuidv4 } from 'uuid'
import tippy from 'tippy.js'
import { useToast } from 'vue-toastification'
import PatientStatsVue from '../../components/PatientStats.vue'

const body = document.getElementsByTagName('body')

export default {
  name: 'PatientDashboard',
  components: { IqCard, FullCalendar, CreateWorkoutPlan, Popper, PatientStatsVue },
  props: ['uid'],
  setup (props) {
    const { document: patient } = getDocument('users', props.uid)
    const firebaseDoctor = firebase.firebaseAuth.currentUser
    const { document: doctor } = getDocument('doctors', firebaseDoctor.uid)
    const { handlelUpdate } = updateDocument('doctors', firebaseDoctor.uid)
    const { documents: plans } = getCollection('exerciseplan')
    const { document: dbScheduledWorkouts } = getDocument('scheduledWorkouts', props.uid)

    // Add or delete patient
    const isMyPatient = ref(null)

    const deletePatient = () => {
      handlelUpdate({ patients: arrayRemove(props.uid) })
    }

    const addPatient = () => {
      handlelUpdate({ patients: arrayUnion(props.uid) })
    }

    // Workout plans
    const publicWorkoutPlans = ref([])
    const personalizedWorkoutPlans = ref([])
    const currentPatientsPlans = ref([])

    watch(doctor, () => {
      if (doctor.value.patients) {
        isMyPatient.value = !!doctor.value.patients.includes(props.uid)
      } else {
        isMyPatient.value = false
      }
    })

    const publicDraggables = ref(null)
    const personalDraggables = ref(null)

    watch(plans, () => {
      publicWorkoutPlans.value = []
      personalizedWorkoutPlans.value = []
      currentPatientsPlans.value = []
      if (plans.value) {
        plans.value.forEach(plan => {
          if (!plan.userID) {
            publicWorkoutPlans.value.push(plan)
          } else if (plan.userID === props.uid) {
            personalizedWorkoutPlans.value.push(plan)
          }
        })
      }
      currentPatientsPlans.value = publicWorkoutPlans.value.concat(personalizedWorkoutPlans.value)

      if (publicDraggables.value) {
        publicDraggables.value.destroy()
      }

      if (personalDraggables.value) {
        personalDraggables.value.destroy()
      }

      publicDraggables.value = new Draggable(document.getElementById('publicDraggables'), {
        itemSelector: 'h6',
        create: true,
        eventData: (eventEl) => {
          return {
            title: eventEl.innerText,
            color: '#b583bc',
            id: uuidv4(),
            extendedProps: { exerciseId: eventEl.id, doctorId: firebaseDoctor.uid }
          }
        }
      })

      personalDraggables.value = new Draggable(document.getElementById('personalDraggables'), {
        itemSelector: 'h6',
        create: true,
        eventData: (eventEl) => {
          return {
            title: eventEl.innerText,
            color: '#5aa9e6',
            id: uuidv4(),
            extendedProps: { exerciseId: eventEl.id, doctorId: firebaseDoctor.uid }
          }
        }
      })
    })

    // Full Calendar Methods - Add or remove events

    // events from outside calendar
    const handleEventReceive = async (info) => {
      const eventsToAdd = {}

      const date = info.event.startStr
      const isPublic = info.event.backgroundColor === '#b583bc'
      eventsToAdd[date] = {}

      eventsToAdd[date][info.event.id] = {
        name: info.event.title,
        isPublic,
        exerciseId: info.event.extendedProps.exerciseId,
        doctorId: info.event.extendedProps.doctorId
      }

      await addWorkoutsToDb(`${info.event.title} scheduled on ${date}.`, eventsToAdd)
    }

    // events from within calendar
    const handleEventDropWithinCalendar = async (info) => {
      const newDate = info.event.startStr
      const oldDate = info.oldEvent.startStr
      const isPublic = info.event.backgroundColor === '#b583bc'

      if (dbScheduledWorkouts.value[oldDate] !== undefined && dbScheduledWorkouts.value[oldDate][info.event.id] !== undefined) {
        console.log('Old event is in db')
        // Remove old event from db
        removeWorkoutFromDb(info.oldEvent, true)
      }

      // Add new event to eventsToAdd
      const eventsToAdd = {}
      eventsToAdd[newDate] = {}

      eventsToAdd[newDate][info.event.id] = {
        name: info.event.title,
        isPublic,
        exerciseId: info.event.extendedProps.exerciseId,
        doctorId: info.event.extendedProps.doctorId
      }

      await addWorkoutsToDb(`${info.event.title} rescheduled for ${newDate}.`, eventsToAdd)
    }

    const {
      createError: updateCalendarError,
      createPending: updateCalendarPending,
      handleCreate: handleUpdateCalendar
    } = createDocument('scheduledWorkouts')
    const updateCalendarSuccessful = ref(false)

    const {
      handleCreate: handleCreateEventRecord
    } = createDocument('scheduledWorkoutsByExercise')

    const addWorkoutsToDb = async (message, events) => {
      // For events to be added in db
      updateCalendarSuccessful.value = false
      await handleUpdateCalendar(props.uid, events)

      const eventsToAddByExericise = {}

      for (const [date, eventsOnDate] of Object.entries(events)) {
        for (const [uuid, exerciseInfo] of Object.entries(eventsOnDate)) {
          if (!eventsToAddByExericise[exerciseInfo.exerciseId]) {
            eventsToAddByExericise[exerciseInfo.exerciseId] = {}
          }

          if (!eventsToAddByExericise[exerciseInfo.exerciseId][date]) {
            eventsToAddByExericise[exerciseInfo.exerciseId][date] = {}
          }
          eventsToAddByExericise[exerciseInfo.exerciseId][date][uuid] = 'uuid'
        }
      }

      for (const [exerciseId, events] of Object.entries(eventsToAddByExericise)) {
        await handleCreateEventRecord(exerciseId, { [props.uid]: events })
      }

      if (!updateCalendarError.value) {
        refreshCalendar()
        makeToast(message)
      } else {
        console.log(updateCalendarError.value)
        makeToast(updateCalendarError.value, 'error')
      }
    }

    const removeWorkoutFromDb = async (event, skipToast = false) => {
      // For events to be removed from db
      const docRef = doc(firebase.db, 'scheduledWorkouts', props.uid)
      await updateDoc(docRef, { [`${event.startStr}.${event.id}`]: deleteField() })

      if (Object.keys(dbScheduledWorkouts.value[event.startStr]).length === 0) {
        await updateDoc(docRef, { [`${event.startStr}`]: deleteField() })
      }

      const byExerciseDocRef = doc(firebase.db, 'scheduledWorkoutsByExercise', event.extendedProps.exerciseId)
      await updateDoc(byExerciseDocRef, { [`${props.uid}.${event.startStr}.${event.id}`]: deleteField() })

      if (!skipToast) {
        makeToast(`${event.title} removed from ${event.startStr}.`, 'warning')
      }
    }

    // Full calendar configs
    const fullCalendar = ref(null)
    watch(fullCalendar, () => {
      setTimeout(() => fullCalendar.value.getApi().updateSize(), 1000)
    })

    const refreshCalendar = () => {
      fullCalendar.value.getApi().removeAllEvents()
      // refetchEvents() alone isn't reliable
      fullCalendar.value.getApi().refetchEvents()
    }

    const eventSourceFunction = (_info, successCallback, failureCallback) => {
      const docRef = doc(firebase.db, 'scheduledWorkouts', props.uid)
      getDoc(docRef)
        .then(docSnap => {
          if (docSnap.exists()) {
            const events = []
            for (const [date, eventsOnDate] of Object.entries(docSnap.data())) {
              for (const [uuid, event] of Object.entries(eventsOnDate)) {
                events.push({
                  id: uuid,
                  title: event.name,
                  color: event.isPublic ? '#b583bc' : '#5aa9e6',
                  start: date,
                  extendedProps: { exerciseId: event.exerciseId, isInDb: true, doctorId: event.doctorId }
                })
              }
            }
            successCallback(Array.prototype.slice.call(events))
          } else {
            failureCallback('No scheduled workouts for this patient yet.')
          }
        }).catch(error => {
          failureCallback(error)
        })
    }

    const calendarOptions = {
      plugins: [dayGridPlugin, interactionPlugin],
      initialView: 'dayGridMonth',
      editable: true,
      unselectAuto: true,
      height: '710px',
      droppable: true,
      events: eventSourceFunction,
      eventReceive: handleEventReceive,
      eventAllow: function (dropInfo) {
        const now = new Date()
        const day = ('0' + now.getDate()).slice(-2)
        const month = ('0' + (now.getMonth() + 1)).slice(-2)
        const today = now.getFullYear() + '-' + (month) + '-' + (day)
        return dropInfo.startStr >= today
      },
      defaultAllDay: true,
      eventDrop: handleEventDropWithinCalendar,
      eventDidMount: function (info) {
        info.el.draggable = false
        const plan = plans.value.filter(plan => plan.id === info.event.extendedProps.exerciseId)[0]
        let exercises = []
        let reps = []
        if (plan.exerciseArray !== undefined) {
          exercises = plan.exerciseArray
          reps = plan.reps
        } else {
          for (const [exerciseName, numReps] of Object.entries(plan.exercises)) {
            exercises.push(exerciseName)
            reps.push(numReps)
          }
        }
        const newDiv = document.createElement('div')
        const listView = document.createElement('ol')
        for (let i = 0; i < exercises.length; i++) {
          const listViewItem = document.createElement('li')
          listViewItem.appendChild(document.createTextNode(`${exercises[i]} x ${reps[i]}`))
          listView.appendChild(listViewItem)
        }
        const btn = document.createElement('button')
        btn.innerHTML = 'Delete'
        btn.classList.add('btn')
        btn.classList.add('btn-secondary')
        btn.onclick = async function () {
          info.event.remove()
          if (info.event.extendedProps.isInDb) {
            console.log('clicked event is in db')
            await removeWorkoutFromDb(info.event)
          }
        }

        newDiv.appendChild(listView)
        newDiv.appendChild(btn)
        tippy(info.el, {
          content: newDiv,
          theme: 'tomato',
          allowHTML: true,
          placement: 'right',
          trigger: 'click',
          interactive: true
        })
      }
    }

    // Respond to events
    const deleteWorkoutPlanSuccessful = ref(false)
    const createWorkoutPlanSuccessful = ref(false)
    const scrollToTop = () => {
      window.scrollTo(0, 0)
    }

    const workoutPlanCreated = () => {
      createWorkoutPlanSuccessful.value = true
      scrollToTop()
      setTimeout(() => {
        createWorkoutPlanSuccessful.value = false
      }, 3000)
    }

    const workoutPlanDeleted = () => {
      deleteWorkoutPlanSuccessful.value = true
      scrollToTop()
      setTimeout(() => {
        deleteWorkoutPlanSuccessful.value = false
      }, 3000)
    }

    const toast = useToast()
    const makeToast = (message, type = 'default') => {
      switch (type) {
        case 'default':
          toast.success(message, {
            timeout: 5000,
            hideProgressBar: true,
            toastClassName: 'custom',
            bodyClassName: 'custom'
          })
          break
        case 'warning':
          toast.warning(message, {
            timeout: 5000,
            hideProgressBar: true,
            toastClassName: 'custom',
            bodyClassName: 'custom'
          })
          break
        case 'error':
          toast.error(message, {
            timeout: 5000,
            hideProgressBar: true,
            toastClassName: 'custom',
            bodyClassName: 'custom'
          })
          break
        default:
          break
      }
    }

    // Click + to add event
    const modalShow = ref(false)
    const searchInput = ref(null)
    const foundPlans = ref([])
    const date = ref(null)
    const selectedPlans = ref([])
    const noDateInput = ref(false)
    const noEventsInput = ref(false)

    watch(searchInput, () => {
      if (searchInput.value) {
        foundPlans.value = currentPatientsPlans.value.filter(plan => {
          return plan.name.toLowerCase().includes(searchInput.value.toLowerCase()) || plan.device.toLowerCase().includes(searchInput.value.toLowerCase())
        })
      }
    })

    watch(selectedPlans, () => {
      if (selectedPlans.value.length) {
        noEventsInput.value = false
      }
    })

    const resetInput = () => {
      searchInput.value = null
    }

    const resetModal = () => {
      searchInput.value = null
      selectedPlans.value = []
      date.value = null
      noDateInput.value = false
      noEventsInput.value = false
    }

    const pickrConfig = {
      minDate: new Date(),
      altFormat: 'M j, Y',
      altInput: true,
      dateFormat: 'Y-m-d',
      disableMobile: 'true'
    }

    const checkValidity = () => {
      noDateInput.value = false
      noEventsInput.value = false
      if (!date.value) {
        noDateInput.value = true
        return false
      }
      if (!selectedPlans.value.length) {
        noEventsInput.value = true
        return false
      }
      return true
    }

    const scheduleEventsUsingModal = (e) => {
      e.preventDefault()

      if (!checkValidity()) {
        return
      }

      const events = {}
      events[date.value] = {}

      selectedPlans.value.forEach(plan => {
        events[date.value][uuidv4()] = {
          name: plan.name,
          isPublic: plan.userID === undefined,
          exerciseId: plan.id,
          doctorId: firebaseDoctor.uid
        }
      })

      addWorkoutsToDb(`Events scheduled on ${date.value}.`, events)
        .then(() => {
          resetModal()
          modalShow.value = false
          refreshCalendar()
        })
    }

    const dateChanged = (e) => {
      noDateInput.value = false
      date.value = JSON.stringify(new Date(e)).slice(1, 11)
    }

    const addPlan = (plan) => {
      selectedPlans.value.push(plan)
    }

    const removePlan = (planIndex) => {
      selectedPlans.value.splice(planIndex, 1)
    }

    return {
      patient,
      deletePatient,
      addPatient,
      doctor,
      isMyPatient,
      calendarOptions,
      publicWorkoutPlans,
      personalizedWorkoutPlans,
      fullCalendar,
      updateCalendarPending,
      updateCalendarSuccessful,
      deleteWorkoutPlanSuccessful,
      createWorkoutPlanSuccessful,
      scrollToTop,
      refreshCalendar,
      workoutPlanCreated,
      workoutPlanDeleted,
      searchInput,
      foundPlans,
      resetInput,
      selectedPlans,
      date,
      pickrConfig,
      modalShow,
      scheduleEventsUsingModal,
      noDateInput,
      noEventsInput,
      resetModal,
      dateChanged,
      addPlan,
      removePlan
    }
  },
  mounted () {
    xray.index()
    body[0].classList.add('sidebar-main-menu')
  },
  unmounted () {
    body[0].classList.remove('sidebar-main-menu')
  }
}
</script>

<style scoped>
  small {
    font-size: 11px;
    color: #585858;
  }
  .profile-pic{
    height: 130px; width: 130px; line-height: 130px; font-size: 1.6rem;
    margin: auto;
  }

  .profile-block {
    margin-top: 65px;
    margin-left: auto;
  }

  .btn.btn-icon {
    color: #b583bc;
}

  .info-btn {
    color: #b583bc;
    padding: 0;
    font-size: 1.2rem;
  }

  .info-btn:hover {
    color: #b583bc;
  }

  .popper-content {
    font-family: -apple-system,BlinkMacSystemFont,Segoe UI,Roboto,Helvetica Neue,Arial,Noto Sans,sans-serif,Apple Color Emoji,Segoe UI Emoji,Segoe UI Symbol,Noto Color Emoji;
    font-weight: 400;
    line-height: 1.5;
    font-size: .875rem;
    background-color: var(--light-grey);
    padding: 20px;
    border-radius: 20px;
    color: #212529;
    padding-top: 30px;
  }

  .modal-content {
    width: 700px;
    height: max-content;
    max-height: 600px;
    overflow-y: auto;
    border: 2px solid #ebecec;
    border-radius: 2%;
    padding-top: 20px;
    padding-bottom: 20px;
    right: 40px;
}

  .iq-search-bar {
    padding: 0;
  }

  .fc-h-event .fc-event-title-container {
    cursor: pointer;
  }
    .v-enter-active,
    .v-leave-active {
        transition: opacity 0.3s ease;
    }

    .v-enter-from,
    .v-leave-to {
        opacity: 0;
    }

    :deep(.popper #arrow::before) {
        background: #e9eef4;
    }

    :deep(.popper:hover > #arrow::before) {
        background: #e9eef4;
    }

    .plan-list {
      margin: 0;
    padding: 0;
    }

    .plan-list li {
      background-color: var(--container-color);
      border-radius: 5px;
      margin: 10px;
    }

    .search-box, .search-input {
      border: none;
      width: 100%
    }

    .plan-btn {
      text-align: left;
    }

    .tag {
      padding: 5px 10px;
      font-family: "Poppins", sans-serif;
      font-style: normal;
      font-size: 12px;
      line-height: 1.8;
      font-weight: 400;
      background:#b583bc;
    }
    .b-form-tags {
      padding: 0;
    }

    .list-inline-item {
      margin-top: 10px;
    }

    .search-box-wrapper {
      border: none;
    }

    .searchbox {
      border: 1px solid rgba(0, 0, 0, 0.2);
      border-radius: 10px;
      line-height: 45px;
      padding: 0 10px;
    }

    .is-invalid {
      border-color: #dc3545;
      padding-right: calc(1.5em + 0.75rem);
      background-image: url("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2712%27 height=%2712%27 fill=%27none%27 stroke=%27%23dc3545%27 viewBox=%270 0 12 12%27%3e%3ccircle cx=%276%27 cy=%276%27 r=%274.5%27/%3e%3cpath stroke-linejoin=%27round%27 d=%27M5.8 3.6h.4L6 6.5z%27/%3e%3ccircle cx=%276%27 cy=%278.2%27 r=%27.6%27 fill=%27%23dc3545%27 stroke=%27none%27/%3e%3c/svg%3e");
      background-repeat: no-repeat;
      background-position: right calc(0.375em + 0.1875rem) center;
      background-size: calc(0.75em + 0.375rem) calc(0.75em + 0.375rem);
    }

</style>

<style>
    .Vue-Toastification__toast--success.custom {
        background: linear-gradient(to right, rgb(8, 155, 171) 0%, rgb(13, 181, 200) 100%);
        top: 90px;
    }

        .Vue-Toastification__toast--warning.custom {
        background: linear-gradient(to right, rgb(120, 125, 118) 0%, rgb(171, 171, 171) 100%);
        top: 90px;
        right: 20px;
    }

    .Vue-Toastification__toast-body.custom {
        font-family: "Poppins", sans-serif;
        font-style: normal;
        font-size: 14px;
        line-height: 1.8;
    }

    .tippy-box[data-theme~='tomato'] {
      background-color: var(--light-grey);
          color: var(--text-color);
        padding: 20px;
        font-family: "Poppins", sans-serif;
        line-height: 1.5;
        border-radius: 20px;
        font-size: .875rem;
        width:max-content;
        height: max-content;
        display: flex;
    }

    .tippy-box[data-theme~='tomato'] button {
        float: right;
    }

      .tippy-box[data-theme~='tomato'] ol {
        padding: 0px;
    }

    .tippy-box[data-theme~='tomato'][data-placement^='right'] > .tippy-arrow::before {
        border-right-color: var(--light-grey);
    }

</style>
